<ng-container *ngIf="!isOrigin">
  <div [ngClass]="class" (click)="imageClicked()">
    <img [src]="imgeBase64" class="mx-auto" [ngClass]="imageClass" [style.width.px]="width" [style.height.px]="height"
    [alt]="alt">
  </div>
</ng-container>

<ng-container *ngIf="isOrigin">
  <div [ngClass]="class" (click)="imageClicked()">
    <img [src]="imgeBase64"
         class="mx-auto"
         [ngClass]="imageClass"
         [alt]="alt">
  </div>
</ng-container>
